export default __webpack_public_path__ + "assets/571c7dcba57503ac7876ce782588af52.png";